import { HttpErrorResponse } from '@angular/common/http';
import { ResetPasswordError } from './reset-password.models';

export function isNetworkError(error: HttpErrorResponse): boolean {
  return error.status === 0;
}

export function getServerErrorMessage(error: HttpErrorResponse): string {
  const body = error.error;

  if (typeof body === 'object' && body !== null && 'message' in body) {
    const message = (body as { message?: unknown }).message;

    if (typeof message === 'string') {
      return message;
    }
  }

  return error.message;
}

export function mapVerifyTokenError(error: HttpErrorResponse): ResetPasswordError {
  return isNetworkError(error) ? 'NETWORK' : 'EXPIRED_TOKEN';
}

export function mapUpdatePasswordError(error: HttpErrorResponse): ResetPasswordError {
  if (isNetworkError(error)) {
    return 'NETWORK';
  }

  if (getServerErrorMessage(error).toLowerCase().includes('same as')) {
    return 'SAME_PASSWORD';
  }

  return 'EXPIRED_TOKEN';
}
